import React, { Component } from "react";
import { Parallax } from "react-parallax";

import ReactGA from "react-ga4";

import Header from "../Components/Header";
import Modal from "../Components/Modal";
import Loader from "../Components/Loader";

import GradientBar from "../Components/GradientBar";
import Hero from "../Containers/Hero";
import Content from "../Containers/Content";
import BuyTicket from "../Containers/BuyTicket";
import ModelSpecs from "../Containers/ModelSpecs";

import { rules_et, rules_ru } from "../Rules/rules";
import { wincar } from "../Rules/wincar";
import Menu from "../Components/Menu";
import CookieModal from "../Containers/CookieModal";

export default class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      showModal: false,
      modalType: "rules",
      language: "et",
      campaignHasEnded: false,
      loading: true,
    };
  }

  componentDidMount() {
    this.getJson();
    if (this.props.match.params.lang === "et") {
      this.changeLanguage("et", false);
    } else if (this.props.match.params.lang === "ru") {
      this.changeLanguage("ru", false);
    }
    if (this.props.match.params.seturl) {
      setTimeout(() => {
        switch (this.props.match.params.seturl) {
          case "win":
            this.showModal("wincar");
            break;
          case "rules":
            this.showModal("rules");
            break;
          case "winners":
            this.goTo("winners");
            break;
          default:
            return false;
        }
      }, 500);
    }
  }


  async getJson() {
    // const response = await fetch("json/winners-example.json");
    const response = await fetch("json/winners.json?t="+Date.now());
    const output = await response.json();
    // waits until the request completes...
    this.setState({
      campaignHasEnded: output.hasCampaignEnded,
      winners: output.winners,
    });
  }

  modalContent = () => {
    const { language } = this.state;
    if (this.state.modalType === "rules") {
      return language === "et" ? rules_et : rules_ru;
    } else if (this.state.modalType === "wincar") {
      return wincar;
    } else {
      return "";
    }
  };

  goTo(ref) {
    document
      .getElementById(ref)
      .scrollIntoView({ behavior: "smooth", block: "start" });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }

  showModal = (type = "rules") => {
    this.setState({
      showModal: true,
      modalType: type,
    });
  };

  changeLanguage = (lang, ga = true) => {
    if (!lang) {
      return lang;
    } else {
      this.setState({
        language: lang,
      });
      if (ga) {
        ReactGA.event({
          category: "keno_2024",
          action: "click",
          label: "change language " + lang,
        });
      
      
      
      }
      return lang;
    }
  };

  render() {
    const { language, campaignHasEnded, winners } = this.state;
    return (
      <>
        {
          //this.state.loading && <Loader />
        }
        <Menu
          language={language}
          changeLanguage={this.changeLanguage}
          modal={this.showModal}
          goTo={this.goTo}
        />
        {!campaignHasEnded ? <BuyTicket language={language} /> : ""}

        <>
          <Hero campaignHasEnded={campaignHasEnded} language={language} />

          <Content
            modal={this.showModal}
            language={language}
            winners={winners}
          />
        </>
        {this.state.showModal ? (
          <Modal close={(e) => this.closeModal()}>{this.modalContent()}</Modal>
        ) : (
          ""
        )}
        <GradientBar />
        <GradientBar align="top" />
        <CookieModal language={language} />
       
      </>
    );
  }
}
